import { render } from "./posts.vue?vue&type=template&id=32a876a7&scoped=true"
import script from "./posts.vue?vue&type=script&lang=js"
export * from "./posts.vue?vue&type=script&lang=js"

import "./posts.vue?vue&type=style&index=0&id=32a876a7&scoped=true&lang=css"
script.render = render
script.__scopeId = "data-v-32a876a7"

export default script